module.exports = __webpack_public_path__ + "36549e14ab14e0d1b26acfbafa4d9686.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jason-logo.png
// module id = 438
// module chunks = 1